import React, { FC, useEffect, useState } from 'react';
import { EditRolesContainer } from './roleScreen.styles';
import { RadioButtonField } from '@sainsburys-tech/luna-react';
import { IApplicationDetails } from 'src/interfaces/application.interface';
import { Button } from '@sainsburys-tech/luna-react';
import { ScreenFeedback } from 'src/screens/components/screenFeedback';
import { ApolloError } from '@apollo/client';
import { NotificationType } from 'src/enums/notificationTypes.enum';
import { PanelActions } from 'src/components/PanelActions/panelActions.styles';

interface IHeading {
  heading: string;
  subHeading: string;
  feedBackStatus: string;
}

interface IRoleUpdateHiddenForRequestsRadioScreen {
  handleClose: () => void;
  handleConfirmation: (status: boolean) => void;
  loading: boolean;
  error: ApolloError | undefined;
  target: { id: string; displayName: string };
  radioHeading: IHeading;
  defaultValue: boolean;
}

export const RoleUpdateHiddenForRequestsScreen: FC<
  IRoleUpdateHiddenForRequestsRadioScreen
> = ({
  handleConfirmation,
  handleClose,
  error,
  radioHeading,
  target,
  defaultValue,
}) => {
  const [selectedValue, setSelectedValue] = useState<boolean | null>(null);
  const [feedBackMessage, setFeedBackMessage] =
    useState<NotificationType | null>(null);
  useEffect(() => {
    if (error) {
      setFeedBackMessage(NotificationType.FAILURE);
    }
  }, [error]);

  const handleReset = () => {
    setSelectedValue(null);
    setFeedBackMessage(null);
  };

  return (
    <>
      <EditRolesContainer>
        {feedBackMessage ? (
          <>
            <ScreenFeedback
              isLoading={false}
              notificationType={feedBackMessage}
              feedBackMessage={
                feedBackMessage === NotificationType.SUCCESS
                  ? `The access has been updated for this role`
                  : `Failed to update the access for this role.`
              }
              saveButtonText={'Save and close'}
              onCloseHandler={handleClose}
              resetButtonText={'Further changes'}
              resetHandler={handleReset}
              notificationMessage={
                feedBackMessage === NotificationType.SUCCESS
                  ? `Role successfully updated`
                  : 'Failed to update role'
              }
            />
          </>
        ) : (
          <>
            <div className='heading-section'>
              <h4 className='display-1 ln-u-margin-bottom*3'>
                {radioHeading.heading}
              </h4>
            </div>
            <div className='panel-body'>
              <RadioButtonField
                label={radioHeading.subHeading}
                name={`${radioHeading.feedBackStatus}-radio-button`}
                fullWidth
                options={[
                  {
                    value: 'true',
                    label: 'Yes',
                    defaultChecked: defaultValue === true ? true : false,
                  },
                  {
                    value: 'false',
                    label: 'No',
                    defaultChecked: defaultValue === false ? true : false,
                  },
                ]}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setSelectedValue(e.target.value === 'true' ? true : false);
                }}
              />
            </div>
          </>
        )}
      </EditRolesContainer>
      {!feedBackMessage && (
        <PanelActions>
          <Button
            onClick={() => {
              if (selectedValue !== null) {
                handleConfirmation(selectedValue);
                setFeedBackMessage(NotificationType.SUCCESS);
              }
            }}
            variant='filled'
            disabled={selectedValue === null}
          >
            Update access
          </Button>
          <Button onClick={handleClose} variant='outlined'>
            Cancel
          </Button>
        </PanelActions>
      )}
    </>
  );
};
